import { Component } from '@angular/core';

@Component({
  selector: 'app-home-tertiary-section',
  templateUrl: './home-tertiary-section.component.html',
  styleUrls: ['./home-tertiary-section.component.css']
})
export class HomeTertiarySectionComponent {

}
